import { baseUrl, GenaiUrl, QuizyUrl, TempUrl } from "../../libs/env";
import { size, find } from "lodash";
import { useLocation } from "react-router-dom";
import get from "lodash/get";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { ShowWarningsModal } from "../../components/modals/ShowWarningsModal";
import { Row } from "reactstrap";
import AssessmentWarnings from "../assessment/assessmentWarnings";
import { join } from "lodash";
import { Assessment } from "../assessment/Assessment";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import { notify } from "../../components/notification/Notification";
import { getStudentid } from "../../libs/api/quiz";
import QuizSubmissionStatus from "./QuizSubmissionStatus";
import { BottomButtonPannel } from "./BottomButtonPannel";
import { Quiz } from "./Quiz";
import { ReportBugButton } from "../../components/buttons/ReportBugButton";
import SaveQuizOnRefresh from "./QuizSubmit";
import quizPayLoadMaker from "./quizPayLoadMaker";
import {DownloadPDFHelper}  from "../exercise/pdf_helper/PdfHelper";
import WaitModel from "../../components/modals/WaitModel";
import QuizWarnings from "./quizSubmissionWarnings";
import AssessmentPayLoadMakerHelper from "../assessment/assessmentPayLoaderMaker";
import InprogressQuizPayload from "./InprogressQuizPayLoad";
import VisualizerModel from "../../components/modals/VisualizerModel";
import SystemRequirementsModal from "../../components/modals/SystemRequirementsModal";
import {
  AccountType,
  exerciseType,
  assessmentFlow,
} from "../../components/constants/constants";
import { toast, ToastContainer } from "react-toastify";
import { Header } from "../../components/header/header";
import AiFeedbackModel from "../../components/modals/AddAIFeedbackModel";
import CheckFeedbackStatus from "../../components/ai_feedback/CheckFeedbackStatus";

let answers = [];
let pushed = false;
let is_saved_assessment = false;
let is_show_assessment_warning = false;
let changed_is_submit_state = false;

export const type = {
  Exercise: "Exercise",
  Assessment: "Assessment",
};

const QuizRunner = ({
  isLoaded,
  data,
  onSubmit,
  isReview,
  isSubmitting,
  setIsSystemRedirection,
  isSystemRedirection,
  onUpdate,
  GenerateFeedback,
  IsFeedbackGenerating,
  setIsFeedbackGenerating
}) => {
  const { pathname } = useLocation();
  let params = new URL(document.location).searchParams;
  let quizy_template = params.get("quizy_template");
  let book_id = params.get("book_id");
  let exercise_page_number = params.get("e-p-n");
  let show_exercises = params.get("s-e");
  let search = params.get("search");
  let st_c_t_c = params.get("st_c_t_c");
  let st_le_c = params.get("st_le_c");
  let ex_b_c = params.get("ex_b_c");
  let st_th_c = params.get("st_th_c");
  let st_fn_c = params.get("st_fn_c");
  let st_gr_c = params.get("st_gr_c");
  let exercise_page_no = params.get("e-p-n");
  let student_level = params.get("level");
  let content_type = params.get("type");
  let test_section_id = params.get("section_id");
  let get_tab = params.get("tab");
  let student_assignment_page_number = params.get(
    "student_assignment_page_number"
  );
  let show_assignment_list = params.get("show_assignment_list");
  let start_date = params.get("start_date");
  let end_date = params.get("end_date");
  let status = params.get("status");
  let exercise_prompt_content = params.get("exercise_prompt_content");
  let task_type = params.get("task_type");
  let student = params.get("student");
  let level = params.get("level");
  let deadline = params.get("deadline");
  let student_name = params.get("student_name");
  let homework_tab_query_string = `student_name=${student_name}&show_assignment_list=${show_assignment_list}&student_assignment_page_number=${student_assignment_page_number}&start_date=${start_date}&end_date=${end_date}&status=${status}&exercise_prompt_content=${exercise_prompt_content}&task_type=${task_type}&student=${student}&level=${level}&deadline=${deadline}`;
  let redirect = params.get("redirect");
  let book_section_id = params.get("section-id");
  let book_chapter_id = params.get("chapter-id");
  let href = null;
  let query_string;
  if (redirect === "grading") {
    href = `${baseUrl}/school/school-quiz-grading/${getStudentid}?level=${student_level}&e-p-n=${exercise_page_no}`;
  } else if (redirect === "book") {
    query_string = `section-id=${book_section_id}&chapter-id=${book_chapter_id}`;
    href = `${baseUrl}/school/book/${book_id}?${query_string}`;
  } else if (redirect === "exercises") {
    query_string = `e-p-n=${exercise_page_number}&s-e=${show_exercises}&reset=false`;
    if (search) {
      query_string = `${query_string}&search=${search}`;
    }
    if (st_c_t_c) {
      query_string = `${query_string}&st_c_t_c=${st_c_t_c}`;
    }
    if (st_le_c) {
      query_string = `${query_string}&st_le_c=${st_le_c}`;
    }
    if (ex_b_c) {
      query_string = `${query_string}&ex_b_c=${ex_b_c}`;
    }
    if (st_th_c) {
      query_string = `${query_string}&st_th_c=${st_th_c}`;
    }
    if (st_fn_c) {
      query_string = `${query_string}&st_fn_c=${st_fn_c}`;
    }
    if (st_gr_c) {
      query_string = `${query_string}&st_gr_c=${st_gr_c}`;
    }
    if (content_type) {
      query_string = `${query_string}&type=${content_type}`;
    }
    href = `${baseUrl}/school/exercises?${query_string}`;
  } else if (redirect === "home") {
    href = `${baseUrl}/school/home`;
  } else if (redirect === "school_assignments") {
    if (get_tab) {
      href = `${baseUrl}/school/${get_tab}?${homework_tab_query_string}`;
    }
  } else if (redirect === "status") {
    if (get_tab) {
      href = `${baseUrl}/a/status/?${homework_tab_query_string}`;
    }
  }
  let container = "container";
  let wraperbackground = "bg-white";
  let padding = "g-0 px-2";
  let quizbackground = "bg-quiz-content";
  let Reportbug="bg-white";
  let margin0="border bg-white border-top-0 px-4 page-break rounded-footer py-3 footer-sticky";
  let spinner_color = "text-light";
  let Quizyheight="pb-4";

  if (pathname.includes(GenaiUrl)) {
    container = "bg-lblue";
    padding = "g-0 px-5";
    quizbackground = "px-5";
    Reportbug = "bg-white d-none";
    Quizyheight = "py-4 min-h-84 quiz-detail-width";
    margin0 = "page-break rounded-footer py-3 g-0";
    spinner_color = "text-white";
  }
  else if (pathname.includes(TempUrl))
  {
    spinner_color = "text-light vh-40"
    container = "";
    padding = "g-0";
    quizbackground = "px-0";
    Reportbug = "bg-white d-none";
    margin0 = "pb-2 mx-0"
    Quizyheight="pb-4 pt-2";

  }
  else if ((redirect === "templates" || redirect === "status" || window.location.origin.includes(QuizyUrl)) && !quizy_template) {
    container = "";
    padding = "g-0";
    Reportbug = "";
    margin0 = "page-break rounded-footer py-4 g-0";
    Quizyheight="min-h-84 pb-4 px-2-900";
    Reportbug = "d-none";
    spinner_color = "text-white";
  }


  const [isSubmit, setIsSubmit] = useState(false);
  const [noPrintanswers, setnoPrintanswers] = useState(false);
  const [message, setMessage] = useState(
    "Please wait whilst we redirect you ..."
  );
  const [showTimeWarning, setShowTimeWarning] = useState(false);
  const [Clearanswers, setClearanswers] = useState(false);
  if (
    data.completed_at &&
    data.completed_at !== null &&
    data.type === type.Exercise
  ) {
    if(noPrintanswers)
    {
      isReview = false;
    }
    else{
      isReview = true;
    }
  }

  if(Clearanswers && isReview)
  {
    isReview = false ;
    data.completed_at = null ;
    answers = [] ;
    var inputElements = document.querySelectorAll('input[type="text"]');
    inputElements.forEach(function(inputElement) {
      inputElement.value = "";
    });
  }

  if (showTimeWarning && !is_show_assessment_warning) {
    const timer1 = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    const time = parseInt(timer1 / 60);
    if (time < 1) {
      is_show_assessment_warning = true;
      toast.error(`You have less than ${timer1} seconds left`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    } else {
      is_show_assessment_warning = true;
      toast.error(`You have ${time} minutes left`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    }
  }
  const [assessmentTimer, setAssessmentTimer] = useState();
  const [assessmentStarted, setAssessmentStarted] = useState(false);
  const [modal, setModal] = useState(false);
  const [resetAudio, setresetAudio] = useState(false);
  const [speakingUrl, setSpeakingUrl] = useState("");
  let [showWarning, setShowWarnings] = useState();
  const [notAnsweredQuestion, setNotAnsweredQuestions] = useState("");
  const toggle = () => setModal(!modal);
  const [saveModal, setSaveModal] = useState(false);

  const [waitModal, setWaitModel] = useState(false);
  const waitToggle = () => setWaitModel(!waitModal);

  const [visualizerModal, setVisualizerModal] = useState(false);
  const visualizerToggle = () => setVisualizerModal(!visualizerModal);
  const [systemrequirementModal, setSystemRequirementModal] = useState(false);
  const systemrequirementToggle = () =>
    setSystemRequirementModal(!systemrequirementModal);

  const [isOpenAdditionalResourceModal, setOpenAdditionalResourceModal] =
    useState(false);

  const additionalResourceToggle = () =>
    setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal);
  const saveToggle = () => setSaveModal(!saveModal);
  const [isStopTimer, setIsStopTimer] = useState(false);
  const [IsonRecorder, setIsonRecorder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [questions, setQuestions] = useState([]);
  const [timer, setTimer] = useState();
  const [answerSheet, setanswerSheet] = useState("");
  const [optionsSheet, setoptionsSheet] = useState("");
  const [GradingModal, setGradingModal] = useState(false);
  const GradingToggle = () => setGradingModal(!GradingModal);
  const [ShowGradingbtn, setShowGradingbtn] = useState(false);
  const [GradeWithAI, setGradeWithAI] = useState(false);

  // console.log("yes", data);

  useEffect(() => {
    if (
      data &&
      data.type === type.Assessment &&
      !test_section_id &&
      size(data?.sections_pages) === 0 &&
      !changed_is_submit_state
    ) {
      changed_is_submit_state = true;
      setIsSubmit(true);
      waitToggle();
    }
  }, [data]);

  useEffect(() => {
    if((!assessmentStarted && data.type === type.Assessment && data.status === "New") || (data.completed_at && data.completed_at !== null && data.type === type.Assessment))
    {
      setIsSystemRedirection(true);
    }
    else if(isSubmit)
    {
      setIsSystemRedirection(true);
    }
    else if (data.completed_at && data.completed_at !== null && data.type === type.Exercise)
    {
      setIsSystemRedirection(true);
    }
    else{
      setIsSystemRedirection(false);
    }
    if (
      data &&
      data.is_browse_alert &&
      data.user_type === AccountType.STUDENT &&
      !isSystemRedirection
    ) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });
  const alertUser = (e) => {
    if (
      data &&
      data.is_browse_alert &&
      data.user_type === AccountType.STUDENT
    ) {
      e.preventDefault();
      e.returnValue = "";
    }
  };

  useEffect(() => {
    let parsed_data_from_local_storage;

    if (data && data.status === "In progress" && !data.completed_at) {
      let fetch_data_from_local_storage = localStorage.getItem(
        `assessment${data.id}${data.school_student_id}${data.student_assessment_id}`
      );
      if (fetch_data_from_local_storage && !pushed) {
        parsed_data_from_local_storage = JSON.parse(
          fetch_data_from_local_storage
        );
        answers = parsed_data_from_local_storage.answers;
        if (parsed_data_from_local_storage.time_spent) {
          setAssessmentTimer(parsed_data_from_local_storage.time_spent);
        }

        pushed = true;
      } else if (!fetch_data_from_local_storage) {
        setAssessmentTimer("00");
      }
    } else if (data && data.status === "New") {
      setAssessmentTimer("00");
    }
  }, [data]);

  InprogressQuizPayload(isReview, data, answers);

  useEffect(() => {
    if(data.type === type.Exercise){
      setTimer(
        data.status === "New" || data.time_spent === null
          ? parseInt(data?.assignment_allowed_time) * 60 
          : get(data, "time_spent")
      );
    }
    setQuestions(get(data, "questions"));
  }, [data]);

  const creatQuizDataAndSubmit = (grading_ai) => {
    if (data.type === type.Assessment) {
      AssessmentSubmit();
    } else {
      QuizSubmit(grading_ai);
    }
  };
  const AssessmentSubmit = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    data &&
      data.sections &&
      data.sections.forEach((section) => {
        section &&
          section.pages &&
          section.pages.forEach((page) => {
            if (size(page.exercises) > 0) {
              page &&
                page.exercises &&
                page.exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_page && !found_exercise) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: [],
                    });
                  }
                  else if (size(exercise.questions) > 0) {
                    exercise &&
                    exercise.questions?.forEach((question) => {
                      if (question.type === "FillInBlank") {
                        let found_from_answer = find(found_exercise.answers, ["question_id", question.id]);
                        if (found_from_answer) {
                          question.prompt_content.replace(
                            /\[\[[^\]]*\]\]/g,
                            function replacer(matched) {
                              let number = parseInt(matched.match(/\d+/)[0]);
                              let found_from_selected_answers = find(
                                found_from_answer.selected_answers,
                                ["number", number]
                              );
                              if (!found_from_selected_answers) {
                                found_from_answer.selected_answers.push({
                                  number: number,
                                  answer: "",
                                });
                              }
                            }
                          );
                        }
                      }
                    });
                  }
                });
            } else if (size(page.writing_exercises) > 0) {
              page &&
                page.writing_exercises &&
                page.writing_exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_exercise && !found_page) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: "",
                    });
                  }
                });
            }
          });
      });

    const spent_timer = parseInt(data.time_allowed_in_minutes * 60 - timer);
    let tempAns = answers;
    answers = [];
    let quiz_data = {
      is_submit: true,
      time_spent: parseInt(spent_timer),
      assessment_id: data.id,
      student_assessment_payload: tempAns,
    };
    if (data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) {
      setIsStopTimer(true);
    }
    if (data.assessment_flow === assessmentFlow.SEQUENTIAL) {
      onSubmit(quiz_data);
      setIsSubmit(true);
      waitToggle();
    } else if (size(data.sections_pages) === 1) {
      onSubmit(quiz_data);
      setIsStopTimer(true);
      setIsSubmit(true);
    } else {
      onSubmit(quiz_data, false);
    }
    setShowWarnings(false);
    setresetAudio(true);
    if (modal === true) {
      toggle();
    } else if (data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) {
      saveToggle();
    }
  };

  const AssessmentSave = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    localStorage.setItem(
      `assessment${data.id}${data.school_student_id}${data.student_assessment_id}`,
      JSON.stringify({ time_spent: parseInt(timer), answers })
    );
    setIsStopTimer(false);
  };

  const AssessmentStatusChangeCall = () => {
    let quiz_data = {
      is_submit: false,
    };
    if (!is_saved_assessment) {
      is_saved_assessment = true;
      onSubmit(quiz_data);
    }
  };

  const AutoSaveAssessmentSubmit = () => {
    const timer = window.sessionStorage.getItem(
      "timer" + data.student_assessment_id
    );
    data &&
      data.sections &&
      data.sections.forEach((section) => {
        section &&
          section.pages &&
          section.pages.forEach((page) => {
            if (size(page.exercises) > 0) {
              page &&
                page.exercises &&
                page.exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_page && !found_exercise) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: [],
                    });
                  }
                  else if (size(exercise.questions) > 0) {
                    exercise &&
                    exercise.questions?.forEach((question) => {
                      if (question.type === "FillInBlank") {
                        let found_from_answer = find(answers.answers, ["question_id", question.id]);
                        if (found_from_answer) {
                          question.prompt_content.replace(
                            /\[\[[^\]]*\]\]/g,
                            function replacer(matched) {
                              let number = parseInt(matched.match(/\d+/)[0]);
                              let found_from_selected_answers = find(
                                found_from_answer.selected_answers,
                                ["number", number]
                              );
                              if (!found_from_selected_answers) {
                                found_from_answer.selected_answers.push({
                                  number: number,
                                  answer: "",
                                });
                              }
                            }
                          );
                        }
                      }
                    });
                  }
                });
            } else if (size(page.writing_exercises) > 0) {
              page &&
                page.writing_exercises &&
                page.writing_exercises.forEach((exercise) => {
                  let found_page = find(answers, ["page_id", page.id]);
                  let found_exercise = find(answers, [
                    "exercise_id",
                    exercise.id,
                  ]);
                  if (!found_exercise && !found_page) {
                    answers.push({
                      section_id: section.id,
                      page_id: page.id,
                      exercise_id: exercise.id,
                      answers: "",
                    });
                  }
                });
            }
          });
      });
    const spent_timer = parseInt(data.time_allowed_in_minutes * 60 - timer);
    let quiz_data = {
      auto_save: true,
      is_submit: true,
      time_spent: parseInt(spent_timer),
      assessment_id: data.id,
      student_assessment_payload: answers,
    };
    setIsStopTimer(true);
    onSubmit(quiz_data);
    setIsSubmit(true);
    changed_is_submit_state = true
    waitToggle();
    setShowWarnings(false);
    // if (modal === true) {
    //   toggle();
    // } else if (data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP) {
    //   saveToggle();
    // }
  };
  const QuizSubmit = (grading_ai) => {
    const timer = window.sessionStorage.getItem("timer");
    let  time_spent;
    if (window.location.origin.includes(QuizyUrl))
    {
      time_spent = parseInt((data.assignment_allowed_time) * 60) - parseInt(timer) ;
    }
    else
    {
      time_spent = parseInt(timer)
    }
    if (speakingUrl !== "") {
      answers = speakingUrl;
      window.localstream.getTracks().forEach((track) => {
        track.stop();
      });
    } else {
      if (data.task_type === exerciseType.PRONUNCIATION_TASK) {
        answers = "";
      }
    }

    if(Clearanswers){
      setClearanswers(false);
    }
    let random_possible_answers = []
    data &&
      data.questions.forEach((question) => {
        if (question.type === "FillInBlank") {
          let found_from_answer = find(answers, ["question_id", question.id]);
          if (found_from_answer) {
            question.prompt_content.replace(
              /\[\[[^\]]*\]\]/g,
              function replacer(matched) {
                let number = parseInt(matched.match(/\d+/)[0]);
                let found_from_selected_answers = find(
                  found_from_answer.selected_answers,
                  ["number", number]
                );
                if (!found_from_selected_answers) {
                  found_from_answer.selected_answers.push({
                    number: number,
                    answer: "",
                  });
                }
              }
            );
          }
        }
        else{
          random_possible_answers.push({
            "id": question.id, "possible_answers": question.possible_answers,
          });
        }
      });
    let grading_with_ai = false;
    if(grading_ai && grading_ai?.grade_with_ai ){
      grading_with_ai = grading_ai?.grade_with_ai;
    }
    let quiz_data = {
      is_submit: true,
      time_spent: time_spent,
      grade_with_ai: grading_with_ai,
      random_possible_answers: random_possible_answers,
      answers,
    };
    setGradeWithAI(grading_with_ai);
    setIsStopTimer(true);
    onSubmit(quiz_data);
    setShowWarnings(false);
    if (modal === true) {
      toggle();
    } 
    else if(!grading_ai?.hide_confirm) {
      saveToggle();
    }
    if (data.task_type === exerciseType.PRONUNCIATION_TASK) {
      waitToggle();
      setIsSubmit(true);
    }
  };

  QuizSubmissionStatus(isSubmit, data, setMessage, setIsSystemRedirection);

  const creatQuizDataAndSave = () => {
    if (data.user_type === AccountType.STUDENT && data.type === type.Exercise) {
      const timer = window.sessionStorage.getItem("timer");
      let quiz_data = {
        is_submit: false,
        time_spent: parseInt(timer),
        answers,
      };

      setIsStopTimer(false);
      onSubmit(quiz_data, false);
      setIsStopTimer(false);
      notify("Successfully Saved!");
    }
  };

  // const AutoSaveQuiz = () => {
  //   if (data.user_type === AccountType.STUDENT && !isReview) {
  //     const timer = window.sessionStorage.getItem("timer");
  //     let quiz_data = {
  //       is_submit: false,
  //       time_spent: parseInt(timer),
  //       answers,
  //     };

  //     onSubmit(quiz_data, false);
  //     setIsStopTimer(false);
  //   }
  // };

  const creatQuizDataThenSaveAndExit = () => {
    if (data.user_type === AccountType.STUDENT) {
      const timer = window.sessionStorage.getItem("timer");
      let quiz_data = {
        is_submit: false,
        time_spent: parseInt(timer),
        answers,
      };

      setIsStopTimer(false);
      onSubmit(quiz_data, true);
      setIsStopTimer(false);
      notify("Successfully Saved!");
    }
  };

  SaveQuizOnRefresh(
    isReview,
    data,
    creatQuizDataAndSave,
    AssessmentSave,
    showWarning
  );

  const onblur = (e) => {
    quizPayLoadMaker(e, answers);
    // AutoSaveQuiz();
  };

  const { handleSubmit } = useForm();

  const onFormSubmit = (e) => {
    if (
      (data.task_type === exerciseType.PRONUNCIATION_TASK && IsonRecorder) ||
      (data.type === type.Assessment && IsonRecorder)
    ) {
      toast.error("Recorder is on, first stop recording then submit quiz", {
        position: "top-right",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        toastId: 1,
      });
    } else {
      let notAnswered;
      notAnswered =
        data.type === type.Assessment
          ? AssessmentWarnings(data, answers)
          : QuizWarnings(data, answers);

      if (size(notAnswered) > 0) {
        data.type === type.Assessment
          ? setNotAnsweredQuestions(notAnswered)
          : setNotAnsweredQuestions(join(notAnswered, ","));

        setModal(!modal);
      } else if (
        data.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP
      ) {
        creatQuizDataAndSubmit();
      } else {
        setSaveModal(!saveModal);
      }
    }
  };

  const AssessmentPayLoadMaker = (e) => {
    AssessmentPayLoadMakerHelper(e, answers);
    AssessmentSave();
  };
  const contentRef = useRef();
  const quesRef = useRef();
  const headerRef = useRef();
  var comp_answer = "";
  var print_options = "";
  const downloadPDF = () => {
    DownloadPDFHelper({contentRef, answerSheet,optionsSheet,setnoPrintanswers});
  };
  
  CheckFeedbackStatus(
    IsFeedbackGenerating,
    setIsFeedbackGenerating,
    data,
    GradingToggle,
    setShowGradingbtn,
    GradeWithAI,
    isReview,
    setGradeWithAI
  );

  if (!isLoaded)
    return (
      <div className={`centered ${spinner_color} fs-4`}>
        <div class="spinner-border h-w-100" role="status"></div>
      </div>
    );
  return (
    <div className={`dashboard-wrapper ${wraperbackground}`}>
      <div class={`${container}`}>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <div className={` row ${padding}`}>
            <div className={`sm-py-1 ${quizbackground}`}>
              <div ref={contentRef}>
                <div className="Header d-none">
                  <Row className="bg-white pb-3">
                    <Header
                      data={data}
                      assessmentStarted={assessmentStarted}
                      click={creatQuizDataThenSaveAndExit}
                      getStudentid={getStudentid}
                    />
                  </Row>
                </div>
                <div class="col-12 pb-0">
                  {data.user_type === AccountType.SCHOOL_ACCOUNT &&
                  !pathname.includes(GenaiUrl) &&
                  !pathname.includes(TempUrl) &&
                  redirect !== "templates" &&
                  redirect !== "status" ? (
                    <nav
                      Style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);"
                      aria-label="breadcrumb"
                    >
                      <ol class="breadcrumb mb-0 pt-2 ps-2">
                        {data && data.book_name && redirect === "book" ? (
                          <>
                            <li class="breadcrumb-item">
                              <a
                                id="breadcrumb_back"
                                href="/school/books"
                                class="text-dark text-decoration-none"
                              >
                                <strong>Content</strong>
                              </a>
                            </li>
                            <li class="breadcrumb-item center">
                              <a
                                id="breadcrumb_back"
                                href={href ? href : "#"}
                                rel="nofollow"
                                class="text-dark text-decoration-none"
                              >
                                <strong>{data.book_name}</strong>
                              </a>
                            </li>
                          </>
                        ) : (
                          <li class="breadcrumb-item">
                            <a
                              id="breadcrumb_back"
                              href={href ? href : "#"}
                              rel="nofollow"
                              class="text-dark text-decoration-none"
                            >
                              <strong>Content</strong>
                            </a>
                          </li>
                        )}
                        <li
                          class="breadcrumb-item active center"
                          aria-current="page"
                        >
                          {data.prompt_content}
                        </li>
                      </ol>
                    </nav>
                  ) : null}
                </div>
                <div className={`quiz-detail ${Quizyheight}`}>
                  {data.type === "Exercise" ? (
                    <Quiz
                      visualizerToggle={visualizerToggle}
                      isReview={isReview}
                      data={data}
                      setIsonRecorder={setIsonRecorder}
                      isStopTimer={isStopTimer}
                      setIsStopTimer={setIsStopTimer}
                      timer={timer}
                      isOpenAdditionalResourceModal={
                        isOpenAdditionalResourceModal
                      }
                      setOpenAdditionalResourceModal={
                        setOpenAdditionalResourceModal
                      }
                      additionalResourceToggle={additionalResourceToggle}
                      setSpeakingUrl={setSpeakingUrl}
                      questions={questions}
                      currentPage={currentPage}
                      onblur={onblur}
                      answers={answers}
                      setCurrentPage={setCurrentPage}
                      onUpdate={onUpdate}
                      setanswerSheet={setanswerSheet}
                      comp_answer={comp_answer}
                      setoptionsSheet={setoptionsSheet}
                      print_options={print_options}
                      quesRef={quesRef}
                      headerRef={headerRef}
                    />
                  ) : (
                    <Assessment
                      systemrequirementToggle={systemrequirementToggle}
                      visualizerToggle={visualizerToggle}
                      setAssessmentStarted={setAssessmentStarted}
                      assessmentStarted={assessmentStarted}
                      isReview={isReview}
                      data={data}
                      IsonRecorder={IsonRecorder}
                      setIsonRecorder={setIsonRecorder}
                      isStopTimer={isStopTimer}
                      setIsStopTimer={setIsStopTimer}
                      timer={assessmentTimer}
                      resetAudio={resetAudio}
                      setresetAudio={setresetAudio}
                      isOpenAdditionalResourceModal={
                        isOpenAdditionalResourceModal
                      }
                      setOpenAdditionalResourceModal={
                        setOpenAdditionalResourceModal
                      }
                      additionalResourceToggle={additionalResourceToggle}
                      setSpeakingUrl={setSpeakingUrl}
                      questions={questions}
                      currentPage={currentPage}
                      onblur={AssessmentPayLoadMaker}
                      answers={answers}
                      setCurrentPage={setCurrentPage}
                      creatQuizDataAndSubmit={AutoSaveAssessmentSubmit}
                      setShowTimeWarning={setShowTimeWarning}
                      showTimeWarning={showTimeWarning}
                      AssessmentStatusChangeCall={AssessmentStatusChangeCall}
                      isSubmitting={isSubmitting}
                    />
                  )}
                  <ToastContainer />
                  {data.type === type.Exercise ? (
                    <>
                      {/* {!pathname.includes(GenaiUrl) &&
                       !pathname.includes(TempUrl) &&
                      data.user_score !== null &&
                      isReview &&
                      data.task_type !== exerciseType.PRONUNCIATION_TASK ? (
                        <Row className="border bg-white border-top-0 border-bottom-0 px-4 pt-2 no-download">
                          <div>
                            <div className="d-score pb-2 align-items-center">
                              <div className="col-lg-4 col-md-4 col-sm-12">
                                <h5 class="text-primary fs-6 mb-0 text-nowrap">
                                  <span>
                                    <strong>
                                      {" "}
                                      Exercise score{" "}
                                      {customRound(data.user_score, 1)} /{" "}
                                      {data.total_score}{" "}
                                      {percentage >= 0
                                        ? `(${percentage}%)`
                                        : `(0%)`}
                                    </strong>
                                  </span>
                                </h5>
                              </div>
                              <div className="col-lg-8 col-md-8 col-sm-12">
                                <BarChart
                                  percentage={
                                    percentage >= 0 ? [percentage] : [0]
                                  }
                                />
                              </div>
                            </div>
                            <p className="quiz-bottom-border"></p>
                          </div>
                        </Row>
                      ) : null} */}
                      <Row id="footer" className={`${margin0}`}>
                        {!pathname.includes(TempUrl) && (
                        <BottomButtonPannel
                          isReview={isReview}
                          IsonRecorder={IsonRecorder}
                          data={data}
                          isSubmitting={isSubmitting}
                          creatQuizDataThenSaveAndExit={
                            creatQuizDataThenSaveAndExit
                          }
                          creatQuizDataAndSave={creatQuizDataAndSave}
                          getStudentid={getStudentid}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          downloadPDF={downloadPDF}
                          setClearanswers={setClearanswers}
                          GradingToggle={GradingToggle}
                          IsFeedbackGenerating={IsFeedbackGenerating}
                          GradeWithAI={GradeWithAI}
                        />)}
                      </Row>
                    </>
                  ) : null}
                </div>
                <Row id="report_bug" className={`lg-display ${Reportbug}`}>
                  <ReportBugButton />
                </Row>
              </div>
            </div>
          </div>
        </form>
        <ShowWarningsModal
          notAnsweredQuestion={notAnsweredQuestion}
          modal={modal}
          toggle={toggle}
          data={data}
          creatQuizDataAndSubmit={creatQuizDataAndSubmit}
          ShowGradingbtn={ShowGradingbtn}
        />
        <ConfirmationModal
          isOpen={saveModal}
          toggle={saveToggle}
          onClick={creatQuizDataAndSubmit}
          ShowGradingbtn={ShowGradingbtn}
        />
        <WaitModel
          data={data}
          isOpen={waitModal}
          toggle={waitToggle}
          message={message}
        />
        <VisualizerModel isOpen={visualizerModal} toggle={visualizerToggle} />
        <SystemRequirementsModal
          data={data}
          isOpen={systemrequirementModal}
          toggle={systemrequirementToggle}
          setAssessmentStarted={setAssessmentStarted}
        />
        <AiFeedbackModel
          isOpen={GradingModal}
          toggle={GradingToggle}
          creatQuizDataAndSubmit={creatQuizDataAndSubmit}
          GenerateFeedback={GenerateFeedback}
          data={data}
        />
      </div>
  
    </div>
  );
};

export default QuizRunner;
